import * as React from 'react';
import { Box, Button, Popover } from '@mui/material';
import EmojiPicker, {Theme} from 'emoji-picker-react';
import AddReactionIcon from '@mui/icons-material/AddReaction';

import ReactionEmoji from './ReactionEmoji';

interface ReactionsModuleProps {
  reactions: { [key: string]: Set<string>; }
  addReaction: Function,
  removeReaction: Function
}

function ReactionsModule(props: ReactionsModuleProps) {
  const [emojiAnchor, setEmojiAnchor] = React.useState<HTMLButtonElement | null>(null);
  
  function selectReaction(event) {
    addReaction(event.emoji);
  }

  function addReaction(emoji) {
    props.addReaction(emoji).then(() => setEmojiAnchor(null));
  }

  function removeReaction(emoji) {
    props.removeReaction(emoji);
  }
  
  return <Box>
    {Object.keys(props.reactions).map(emoji => <ReactionEmoji key={emoji} emoji={emoji} userList={props.reactions[emoji]} addReaction={addReaction} removeReaction={removeReaction} />)}
    <Button onClick={event => setEmojiAnchor(event.currentTarget)}><AddReactionIcon /></Button>
    <Popover
      open={!!emojiAnchor}
      anchorEl={emojiAnchor}
      onClose={() => setEmojiAnchor(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <EmojiPicker reactionsDefaultOpen={true} theme={Theme.DARK} onReactionClick={selectReaction} onEmojiClick={selectReaction} />
    </Popover>
  </Box>
}

export default ReactionsModule;
